import React, { Component } from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import {
  Card, CardImg, CardText, CardBody, CardTitle,
} from 'reactstrap';

import { Link } from 'react-router-dom';

const styles = {
  cardContainer: {
    marginRight: '2rem',
    marginBottom: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
      boxShadow: 'rgb(187, 187, 187) -2px 0px 8px',
    },
  },
  card: {
    minWidth: '16.25rem',
    maxWidth: '16.25rem',
    minHeight: '16.25rem',
    maxHeight: '16.25rem',
    borderRadius: '0.3125rem',
  },
  title: {
    marginBottom: '1rem',
    fontSize: '0.9rem',
    fontFamily: 'Lato, Arial',
    color: '#1F1F1F',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  description: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#656565',
    lineHeight: '1.3125rem',
    // TODO: this only works on Chrome
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 7,
    WebkitBoxOrient: 'vertical',
    // END TODO
  },
  cardImgWrapper: {
    width: 'calc(100% - 2rem)',
    margin: '0px auto 1rem',
  },
};

class JamRecipesCard extends Component {
  render() {
    const { classes, title, description, number, onClick, slug } = this.props;

    return (
      <Link className={classes.cardContainer} onClick={onClick} to={`/create/${slug}/select`}>
        <Card className={classes.card}>
          <CardBody>
            <CardTitle className={classes.title}>{title}</CardTitle>
            <CardText className={classes.description}>{description}</CardText>
          </CardBody>
          <div className={classes.cardImgWrapper}>
            <CardImg top width="100%" src={require(`../assets/photos/Jam${number}.svg`)} alt="Card image cap" />
          </div>
        </Card>
      </Link>
    );
  }
}

JamRecipesCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(JamRecipesCard);



// WEBPACK FOOTER //
// ./src/components/JamRecipesCard.js